module.exports = __webpack_public_path__ + "fonts/MyriadPro-CondIt.417d536.woff";